import { getStaticImg } from "../../../../utils/function";
import { Wave, Text } from "../../../atoms";
import useWindowSize from "../../../../hooks/useWindowSize";

const Award = ({}) => {
  const { size } = useWindowSize();
  const assetPath =
    (size?.width || 0) <= 767.98 ? "pre-award-center" : "pre-award";
  return (
    <div className="awards" id="awards-section">
      <div className="awards__illustration-description--m">
        <Text
          weight="bold"
          size="large"
          className="awards__illustration-description--m__title"
        >
          Rebut Piala by.U PERTAMA di Kota Semarang
        </Text>
      </div>

      <div className="awards__content">
        <img
          src={getStaticImg("illustration/piala-money.svg")}
          alt={"illustration-awards"}
          className="awards__illustration--awards"
        />
        <div className="awards__illustration-description--d">
          <Text
            weight="bold"
            size="large"
            className="awards__illustration-description--d__title"
          >
            Rebut Piala by.U PERTAMA di Kota Semarang
          </Text>
          <img
            src={getStaticImg(`typography/${assetPath}.png`)}
            srcset={`${getStaticImg(
              `typography/${assetPath}.png`
            )} 1x, ${getStaticImg(
              `typography/${assetPath}@2x.png`
            )} 2x, ${getStaticImg(`typography/${assetPath}@3x.png`)} 3x`}
            className="awards__illustration-description--d__price"
            alt={"Dan Menangkan Berbagai Hadiahnya!"}
          />
          {/* <Text
            weight="bold"
            size="large"
            className="awards__illustration-description--d__price"
          >
            Dan Menangkan Berbagai Hadiahnya!
          </Text> */}
          <Text
            size="small"
            className="awards__illustration-description--d__description"
          >
            Terbuka untuk 16 SMA pendaftar pertama
          </Text>
        </div>
      </div>
      <div className="awards__illustration-description--m">
        <img
          src={getStaticImg(`typography/${assetPath}.png`)}
          className="awards__illustration-description--m__price"
          alt={"Dan Menangkan Berbagai Hadiahnya!"}
        />
        <Text
          size="small"
          className="awards__illustration-description--m__description"
        >
          Terbuka untuk 16 SMA pendaftar pertama
        </Text>
      </div>
    </div>
  );
};
export default Award;
